exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tbody > tr[data-v-22cdab1e] {\n  font-weight: 400;\n}\n", ""]);

// exports
